import React from 'react';
import { bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Popover, PopoverAnchor, PopoverChevron, PopoverContent } from '@fiverr-private/popover';
import { colorGrey1100 } from '@fiverr-private/sass/helpers/index';
import withTranslationButtonWrapper from '../../TranslationButtonWrapper';

const TranslationButton = ({
    toggled = false,
    loading = false,
    isOpen = false,
    onClick = Function.prototype,
    setIsHovered = Function.prototype
}) => {
    const isOriginal = !toggled || loading;

    return (
        <Popover isOpen={isOpen}>
            <PopoverAnchor>
                <button onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={onClick}
                    disabled={loading}>
                    {isOriginal ?
                        <I18n k={'machine_translation.translate'}/> :
                        <I18n k={'machine_translation.lean_with_disclaimer.cta_translate'}/>}
                </button>
            </PopoverAnchor>
            <PopoverContent backgroundColor={colorGrey1100}>
                <PopoverChevron/>
                <span className="co-grey-100">
                    <I18n k={'machine_translation.lean_with_disclaimer.tooltip'}/>
                </span>
            </PopoverContent>
        </Popover>
    );
};

TranslationButton.propTypes = {
    toggled: bool,
    loading: bool,
    isOpen: bool,
    onClick: func,
    setIsHovered: bool
};

export default withTranslationButtonWrapper(TranslationButton);
